import { PowerFunnelGatedFeatures } from '../../Analytics/constants';
import CppUpgradeLeftColumn from './CppUpgradeLeftColumn';

const LEFT_COLUMN_BY_GATED_FEATURE = {
    [PowerFunnelGatedFeatures.CPP_TARGET_COLLEGES_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_RECOMMENDED_EVENTS_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_COLLEGE_FIT_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_RECRUITING_STATUS_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_COACH_ACTIVITY_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_COLLEGE_COACH_VIEWS_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_SOCIAL_HANDLES_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_RECRUITING_AGENCY_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_RECRUITING_VIDEOS_LOCKED]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_GET_POWER_CTA]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_DISCOVERY_BANNER_CTA]: CppUpgradeLeftColumn,
    [PowerFunnelGatedFeatures.CPP_ACADEMICS_EDIT_LOCKED]: CppUpgradeLeftColumn,
};

export const getLeftColumnVariantFor = (gatedFeature) => LEFT_COLUMN_BY_GATED_FEATURE[gatedFeature] || null;
